module.exports = __webpack_public_path__ + "assets/tourist.59f6b69c.svg";